import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from './components/ui/card';
import { ClipboardList, IndianRupee, CreditCard } from 'lucide-react';
import { useNavigation } from './contexts/NavigationContext';

function Sheets({ currentView }) {
  const { navigate } = useNavigation();
  return (
      <main className="w-full px-4 py-8 space-y-8 max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="space-y-2 text-left">
          <h1 className="text-4xl font-bold text-left">Sheets</h1>
          <p className="text-base text-muted-foreground text-left">Daily operations and data management</p>
        </div>

       {/* Action Cards Grid */}
       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
         
         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('updateClosingStock')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <ClipboardList className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Update Closing Stock</CardTitle>
                 <CardDescription className="text-left">Update end-of-day closing stock quantities</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('incomeExpenses')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <IndianRupee className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Income/Expenses</CardTitle>
                 <CardDescription className="text-left">Record additional income sources and operational expenses</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('trackPayments')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <CreditCard className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Track Payments</CardTitle>
                 <CardDescription className="text-left">Record daily payment collections</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

       </div>
    </main>
  );
}

export default Sheets;
